import { Settings } from "../../Settings";
import { JsonBasketRow } from "../json-data-types/JsonBasketRow";
import { JsonProduct } from "../json-data-types/JsonProduct";
import { ServerCategories } from "../server-queries/ServerCategories";
import { EnumEcomActionType } from "./EnumEcomActionType";
import { JsonEcomActionField } from "./JsonEcomActionField";
import { JsonEcomProduct } from "./JsonEcomProduct";


// https://stackoverflow.com/questions/56457935/typescript-error-property-x-does-not-exist-on-type-window
declare global{
    interface Window{
        dataLayer: any[]
    }
}


// ecommerce module via DataLayer
// https://yandex.ru/support/metrica/ecommerce/data.html#data
export module Ecom{

    export async function visitProductDetailsAsync(product:JsonProduct){
        //window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            "ecommerce": {
                "currencyCode": "RUB",
                [EnumEcomActionType.VisitProductDetails]:{
                    "products":[
                        await convertJsonProductToJsonEcomProductAsync(product)
                    ]
                }
            }
        })
    }

    async function convertJsonProductToJsonEcomProductAsync(product:JsonProduct, quantity?:number, productAttributes?:Object){
        const result:JsonEcomProduct = {
            id: product.sku,
            name: product.name,
            price: product.retailPrice,
            category: await getCategoriesPathAsStringForProductAsync(product),
        }
        if(quantity && quantity>0){
            result.quantity = quantity
        }
        if(productAttributes){
            result.variant = JSON.stringify(productAttributes)
        }
        return result
    }

    async function getCategoriesPathAsStringForProductAsync(product:JsonProduct):Promise<string>{
        // const allProductCategories = await ServerCategories.getAllCategoriesAsync()
        const categoryId = product.categoryId
        // const category = allProductCategories.find(category => category.id == categoryId)
        let category = await ServerCategories.getCategoryByIdAsync(categoryId)
        if(!category) return 'нет-категории'
        const resultArray = [category.name]
        while(category.parentId){
            category = await ServerCategories.getCategoryByIdAsync(category.parentId)
            if(category){
                resultArray.unshift(category.name)
            }
        }
        return resultArray.join(' / ')
    }

    export async function addProductToBasketAsync(product:JsonProduct, quantity:number, productAttributes?:Object){
        window.dataLayer.push({
            "ecommerce": {
                "currencyCode": "RUB",    
                [EnumEcomActionType.AddProductToBasket]: {
                    "products": [
                        await convertJsonProductToJsonEcomProductAsync(product, quantity, productAttributes)
                    ]
                }
            }
        })
    }

    export async function removeProductFromBasketAsync(product:JsonProduct, quantity:number, productAttributes?:Object){
        window.dataLayer.push({
            "ecommerce": {
                "currencyCode": "RUB",
                [EnumEcomActionType.RemoveProductFromBasket]: {
                    "products": [
                        await convertJsonProductToJsonEcomProductAsync(product, quantity, productAttributes)
                    ]
                }
            }
        })
    }

    export async function newOrderAsync(orderId:number, products:JsonBasketRow[], couponCodes:string[]){
        const actionField:JsonEcomActionField = {
            id: 'id'+orderId,
            coupon: (couponCodes || []).join(', '),
            goal_id: Settings.ecomYandexNewOrderGoalId,
            // revenue: order.totalRetailSum, //TODO: check this field!
        }
        const ecomProducts:JsonEcomProduct[] = []
        for(let row of products){
            let ecomProduct = await convertJsonProductToJsonEcomProductAsync(row.product, row.quantity)
            if(row.productChosenAttributes){
                ecomProduct.variant = JSON.stringify(row.productChosenAttributes)
            }
            ecomProducts.push(ecomProduct)
        }
        window.dataLayer.push({
            "ecommerce": {
                "currencyCode": "RUB",
                [EnumEcomActionType.NewOrder]: {
                    actionField,
                    "products": ecomProducts
                }
            }
        })
    }

    


}